const commonFormat = {
    short: {
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    },
    long: {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }
};

module.exports = {
    'en': commonFormat,
    'es': commonFormat
};


// WEBPACK FOOTER //
// ./conversationTranscript/defaultTimeFormats.js